<div id="firstDiv" tabindex="1"></div>
<a id="skip-link" role="button" class="btn btn-primary skip-link" tabindex="2" href (keydown)="skipNavigation($event)"
(click)="skipNavigation($event)" aria-label="Skip to Main Content">Skip to Main Content</a>

<nav id="mainNavbar" class="border-bottom navbar navbar-expand-lg" aria-label="Main Navigation Menu">
  <a [routerLink]='[defaultHomepageLink]' class="navbar-brand shadow-right">
    <img src="../../../../../assets/images/LN-Orb-KO.svg" role="img" alt="brand">
  </a>
  <a class="navbar-brand product-name" [routerLink]='[defaultHomepageLink]' href="javascript:void(0);" aria-label="Reed Tech SingleSource">Reed Tech
    SingleSource&trade; for Drug Products</a>
  <button class="navbar-toggler" type="button" role="button" data-bs-toggle="collapse" data-bs-target=".navbarNav"
    aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="navbar-links collapse navbar-collapse navbarNav">
    <ul class="navbar-nav" *ngIf='loggedIn && permissionsSet' role="list">
      <li ngbDropdown class="nav-item" *ngIf="loggedIn && (ingestBNCC || hcValidationFormMenu || splViewLLForm)" role="listitem">
        <a href="#" (click)="false" class="nav-link" ngbDropdownToggle tabindex="0" aria-label="Uploads">Uploads</a>
        <div ngbDropdownMenu>
          <a *ngIf="hcValidationFormMenu" [routerLink]='["/health-canada-spl-validation"]' ngbDropdownItem tabindex="0"
          aria-label="SPL Health Canada Validation">SPL Health Canada Validation</a>
          <a *ngIf="ingestBNCC" [routerLink]='["/bncc/validation"]' ngbDropdownItem tabindex="0"
          aria-label="Blanket No Changes Builder">Blanket No Changes Builder</a>
          <a *ngIf="ingestPLRSPL" [routerLink]='["/label-spl/builder"]' ngbDropdownItem tabindex="0"
          aria-label="Drug Labeling SPL Builder">Drug Labeling SPL Builder</a>
          <a *ngIf="substanceLookup" [routerLink]='["/substance-lookup"]' ngbDropdownItem tabindex="0"
          aria-label="Substance lookup">Substance Lookup</a>
          <a *ngIf="substanceLookup" [routerLink]='["/cosmetic-builder"]' ngbDropdownItem tabindex="0"
          aria-label="Cosmetic SPL Builder">Cosmetic SPL Builder</a>
          <feature name="ssdp-spl-upload">
            <a *ngIf="splViewLLForm || splIngestLLForm" [routerLink]='["/spl-upload"]' ngbDropdownItem tabindex="0"
            aria-label="SPL Upload">SPL Upload</a>
          </feature>
        </div>
      </li>
      <li role="listitem"><a *ngIf="loggedIn && editCompanyMenu" href="#" class="nav-link"
          [routerLink]='["/company-dashboard"]' tabindex="0" aria-label="Companies" role="navigation">Companies</a></li>
      <li role="listitem"><a *ngIf="loggedIn && editContactMenu" href="#" class="nav-link"
          [routerLink]='["/contact-dashboard"]' tabindex="0" aria-label="Contacts" role="navigation">Contacts</a></li>

      <li ngbDropdown class="nav-item" *ngIf="loggedIn && editLCRFormMenu || editERFormMenu || editBNCCFormMenu" role="listitem">
        <a href="#" (click)="false" class="nav-link" ngbDropdownToggle tabindex="0" aria-label="Registrations">Registrations</a>
        <div ngbDropdownMenu>
          <a *ngIf="loggedIn && editLCRFormMenu" [routerLink]='["/lcr-form-dashboard"]' ngbDropdownItem tabindex="0"
          aria-label="Labeler Code Requests">Labeler Code Requests</a>
          <a *ngIf="loggedIn && editERFormMenu" [routerLink]='["/er-form-dashboard"]' ngbDropdownItem tabindex="0"
          aria-label="Establishment Registrations">Establishment Registrations</a>
          <a *ngIf="loggedIn && editBNCCFormMenu" [routerLink]='["/bncc"]' ngbDropdownItem tabindex="0"
          aria-label="Blanket No Changes Certification">Blanket No Changes Certification</a>
        </div>
      </li>
      <li class="nav-item" role="listitem"><a *ngIf="loggedIn && editLLFormMenu" class="nav-link" href="#"
          [routerLink]='["/products/portfolio"]' tabindex="0" aria-label="Product Portfolio" role="navigation">Product Portfolio</a></li>
      <li ngbDropdown class="nav-item" *ngIf="loggedIn && ordersFormMenu" role="listitem">
        <a href="#" (click)="false" class="nav-link" ngbDropdownToggle tabindex="0" aria-label="Orders">Orders</a>
        <div ngbDropdownMenu>
          <a *ngIf="loggedIn && editOrdersMenu" [routerLink]='["/order"]' ngbDropdownItem tabindex="0"
          aria-label="Add Order">Add Order</a>
          <a *ngIf="loggedIn && ordersFormMenu" [routerLink]='["/order-tracker"]' ngbDropdownItem tabindex="0"
          aria-label="Order Tracker">Order Tracker</a>
        </div>
      </li>
      <li class="nav-item" role="listitem"><a *ngIf="loggedIn" href="#" class="nav-item nav-link" [routerLink]='["/submission-dashboard"]' tabindex="0"
        aria-label="Submission Dashboard">Submission Dashboard</a></li>
      <li class="nav-item" role="listitem"><a *ngIf="loggedIn" href="#" class="nav-item nav-link" [routerLink]='["/support"]' tabindex="0"
        aria-label="Support and Feedback">Support &amp; Feedback</a></li>
      <li class="nav-item" role="listitem"><a *ngIf="loggedIn" href="#" class="nav-item nav-link" [routerLink]='["/navigator"]' tabindex="0"
        aria-label="Navigator for Drug Labels">Navigator</a></li>
    </ul>
    <ul class="nav navbar-right" role="list">
      <li *ngIf="loggedIn" class="greeting flex-grow-1 flex-shrink-1 text-end" role="listitem"><span tabindex="0"
        aria-label="Greeting area - Hello logged in user">Hello {{userName | splitWords:" ":0
          }}</span> <a *ngIf="loggedIn && editBusinessCategoryMenu" href="#"
          [routerLink]='["/business-category"]' tabindex="0" aria-label="Settings"><span>
            <i class="fas fa-cog ps-2"></i></span></a></li>
      <li *ngIf="loggedIn" class="flex-grow-1 flex-shrink-1 text-end" role="listitem">
        <a (click)="logout()" class="nav-link py-0" tabindex="0" aria-label="Sign Out">
          <i class="fas fa-sign-out-alt"></i>
          Sign Out
        </a>
      </li>
    </ul>
  </div>
</nav>
<nav *ngIf="customerSelectionEnabled" class="company-selector" [hidden]="!userData">
  <div class="container">
    <!--Collect the nav links, forms, and other content for toggling-->
    <div [hidden]="!userData">
      <ul class="nav">
        <li class="nav-item">
          <p class="navbar-text hide-small" aria-label="Select a different company">Company</p>
        </li>
        <li class="navbar-dropdown nav-item">
          <ejs-dropdownlist #switchCustomersddw id='switchCustomersddw' [dataSource]='customers' [width]='drpWidth'
            [fields]='fields' (change)='switchClient($event)' [(value)]='customerId' [popupWidth]='ddwWidth'
            [popupHeight]='ddwHeight' [hidden]='customers?.length === 1 || toggleClientDropdownState' aria-label="company selector" role="listbox">
          </ejs-dropdownlist>

          <input *ngIf='customers?.length === 1 || toggleClientDropdownState' class="form-control"
            [value]="currentCustomer?.customerName" disabled />
        </li>
      </ul>
    </div>
    <!--/.navbar-collapse-->
  </div>
  <!--/.navbar-collapse-->
</nav>
